import React from "react";
import { useTranslation } from "react-i18next";
import StepNavigation from "./StepNavigation";
import "../../styles/steps.css";

const BUILDING_TYPES = [
  "building_new",
  "building_old",
  "building_under_construction",
];

export default function StepBuilding({ listing, setListing, onNext, onBack }) {
  const { t } = useTranslation();

  return (
    <div className="step">
      <h2 className="step-title">{t("building_type")}</h2>

      <div className="option-grid small">
        {BUILDING_TYPES.map((b) => (
          <button
            key={b}
            type="button"
            className={`option-card ${
              listing.building === b ? "active primary" : ""
            }`}
            onClick={() =>
              setListing((prev) => ({ ...prev, building: b }))
            }
          >
            {t(b)}
          </button>
        ))}
      </div>

      {/* CADASTRAL CODE */}
      <div className="form-group">
        <label className="form-label">
          {t("build.cadastral_code")} <span className="optional">({t("optional")})</span>
        </label>

        <input
          type="text"
          className="form-input"
          value={listing.cadastralCode || ""}
          onChange={(e) =>
            setListing({ ...listing, cadastralCode: e.target.value })
          }
          placeholder="01.10.05.123.456"
        />
      </div>

      <StepNavigation
        onBack={onBack}
        onNext={onNext}
        nextDisabled={!listing.building}
      />
    </div>
  );
}
